import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import "./Amc.css";
import { Modal } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { AiFillCloseCircle } from "react-icons/ai";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Amc() {
  const [data, setData] = useState([]);
  const [Fetchdata, getData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/AMC-Board",
      "jmf_about-us_amc-board"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "AMC Board Page Loaded",
      label: "jmf_about-us_amc-board",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetAboutUs", {
      teamid: 3,
      INprofile: 0,
      // designation: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);
  const handleClosePopup = () => {
    setShow(false);
  };
  const newsModal = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    let filteredCompanyInformation = data.filter((oneData) => {
      return parseInt(oneData["srno"]) === parseInt(fetchId);
    });
    setFilteredNewsData(filteredCompanyInformation);
    handleShow();
  };

  return (
    <>
      <section className="trustee-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>AMC Board</h2>
                {/*  <h5>JM Financial Trustee Company Private Limited</h5> */}
              </div>
            </Col>
            <Col sm={12}>
              <div className="about-common-left">
                <h3>Corporate Office</h3>
                <p>
                  One International Centre, 22nd Floor, Tower 2, Senapati Bapat
                  Marg, Prabhadevi, Mumbai – 400013.
                </p>
                <p>
                  <span className="blackspan">Tel. No.:</span> 022-3379 7777
                </p>
                <p>
                  <span className="blackspan">Fax No.:</span> 022- 2652 8388
                </p>
              </div>
              <div className="about-common-right">
                <p>
                  JM Financial Asset Management Ltd.(AMC) is a public limited
                  company incorporated under the Companies Act, 1956 on 9th
                  June, 1994., having its registered office at 7th Floor,
                  Cnergy, Appasaheb Marathe Marg, Prabhadevi, Mumbai 400 025,
                  India. JM Financial Asset Management Ltd. has been appointed
                  as the Asset Management Company of JM Financial Mutual Fund by
                  the Trustee vide Investment Management Agreement (IMA) dated
                  1st September, 1994, executed between JM Financial Trustee
                  Company Pvt. Ltd and JM Financial Asset Management Ltd.
                  Supplemental IMA has been executed on March 25, 2013 between
                  JM Financial Trustee Company Pvt. Ltd and JM Financial Asset
                  Management Ltd. The AMC Board is acting as Investment Manager
                  to Category II Alternative Investment Funds (AIF) in
                  accordance with Regulation 24 (b) of SEBI (Mutual Funds)
                  regulations.
                </p>
                {/* (formerly known as JM Financial Asset Management Private Ltd.) */}
              </div>
            </Col>
            <Col sm={12}>
              {/* <h5>
                The Board of AMC comprises of eminent personalities with
                varied experience, details are as given below:
              </h5> */}
              <h4 className="trusteef">
                Details of AMC Board-Accomplished individuals, Diverse
                experience
              </h4>
              <div className="member-main">
                {/* {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                {data &&
                  data.map(({ name, desgination, filename, srno, image }) => (
                    <div className="board-pnl">
                      <div className="">
                        <img
                          // src={BaseURL.replace("api/", "") + image}
                          src={image}
                          data-id={srno}
                          onClick={newsModal}
                          alt={name}
                          className="img-fluidd img-about"
                        />
                        <h4 className="name">{name}</h4>
                        <p>{desgination}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
            {filteredNewsData === null ? (
              <h5 className="errormsgComNew">No Data Available !!!</h5>
            ) : (
              ""
            )}

            {filteredNewsData &&
              filteredNewsData.map(
                ({ name, description, desgination, image }) => (
                  <Modal
                    show={show}
                    className="modal modal-teams"
                    onHide={handleClosePopup}
                    autoFocus={true}
                    backdrop="static"
                    keyboard={true}
                    className="modal modal-teams"
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body id="modal_info">
                      {/* <div className="btnDiv">
                        <div className="" onClick={handleClosePopup}>
                          <AiFillCloseCircle className="btncl" />
                        </div>
                      </div> */}
                      <div className="modal-info">
                        <div className=" img-about-modal">
                          <img src={image} alt={name} className="img-fluidd" />
                          <div className="titleCompany">
                            <h5>{desgination}</h5>
                            <hr className="hrtrust"></hr>
                          </div>
                        </div>
                        <div className="infoCompany">
                          <h4>{name}</h4>
                          <hr className="hrtrust"></hr>
                          <p className="popupAmc">{description}</p>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                ),
              )}
            {loadingshow ? (
              <div className="textcentervertex">
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div>
            ) : (
              ""
            )}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Amc;
